<template>
    <header class="header">
        <span class="header__title">Mijn Markt</span>

        <template>
            <!--<a href="#" class="nav__toggle_mobile" @click="toggleMobileMenu">-->
                <!--Menu-->
                <!--<span class="nav__toggle_mobile__icon">-->
                    <!--<transition name="fade">-->
                        <!--<i class="mdi mdi-menu" v-show="!showMobileMenu"></i>-->
                    <!--</transition>-->
                    <!--<transition name="fade">-->
                        <!--<i v-show="showMobileMenu" class="mdi mdi-close"></i>-->
                    <!--</transition>-->
                <!--</span>-->
            <!--</a>-->

            <!--<nav class="nav" :class="{ 'is-active': showMobileMenu }">-->
                <!--<ul>-->
                    <!--<li class="nav__item">-->
                        <!--<router-link :to="{ name: 'home' }" @click.native="toggleMobileMenu" class="nav__link">Home</router-link>-->
                    <!--</li>-->
                    <!--<li class="nav__item ">-->
                        <!--<router-link :to="{ name: 'styleguide' }" @click.native="toggleMobileMenu" class="nav__link">Styleguide</router-link>-->
                    <!--</li>-->
                    <!--<li class="nav__item">-->
                        <!--<router-link :to="{ name: 'auth' }" @click.native="toggleMobileMenu" class="nav__link">Authentication</router-link>-->
                    <!--</li>-->
                    <!--<li class="nav__item&#45;&#45;mobile">-->
                        <!--<div @click.prevent="logout" class="nav__link">Log out</div>-->
                    <!--</li>-->
                <!--</ul>-->
            <!--</nav>-->

            <!--&lt;!&ndash;<button @click.prevent="logout" class="header__logout">Log out</button>&ndash;&gt;-->
        </template>
    </header>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import vMediaQuery from 'v-media-query';
    import firebase from 'firebase';

    Vue.use(vMediaQuery);

    @Component({
        watch: {
            '$mq.resize': 'hideMobileMenu',

            showMobileMenu: function(newVal) {
                const className = 'nav__mobile_open';
                if (newVal) {
                    document.body.classList.add(className);
                } else {
                    document.body.classList.remove(className);
                }
            }
        }
    })
    export default class TheHeader extends Vue{
        name = 'the-header';
        showMobileMenu = false;

        toggleMobileMenu() {
            if (this.$mq.below(768)) {
                this.showMobileMenu = !this.showMobileMenu;
            } else {
                this.showMobileMenu = false;
            }
        }

        hideMobileMenu() {
            if (this.$mq.above(767)) {
                this.showMobileMenu = false;
            }
        }

        created() {
            this.showMobileMenu = false;
        }

        logout() {
            console.log('Sign our');
            firebase.auth().signOut();
        }
    }

    Vue.component('the-header', TheHeader);
</script>



// WEBPACK FOOTER //
// src/components/general/TheHeader.vue